import React from 'react';
import { Box, Chip, lighten, useTheme } from '@material-ui/core';
import { IStoreTag } from 'src/constants/store/tags';

type TTagFilterOption = IStoreTag & { isAll?: boolean };

export const SelectableTags = ({
    tags,
    currentTags,
    onSelect,
}: {
    tags: IStoreTag[];
    currentTags: IStoreTag[];
    onSelect: (tag: IStoreTag) => void;
}) => {
    const theme = useTheme();

    const isTagActive = (tag: TTagFilterOption) => {
        return currentTags.some((currentTag) => currentTag.name === tag.name);
    };

    const renderTagIcon = (tag: TTagFilterOption) => {
        if (!tag.icon) return null;

        return <span style={{ marginRight: 4 }}>{tag.icon}</span>;
    };

    const renderTagChip = (tag: TTagFilterOption) => {
        const isActive = isTagActive(tag);

        return (
            <Chip
                variant={isActive ? 'default' : 'outlined'}
                key={tag._id}
                label={
                    <Box display="flex" alignItems="center">
                        {renderTagIcon(tag)}
                        {tag.name}
                    </Box>
                }
                style={{
                    cursor: onSelect ? 'pointer' : 'default',
                    maxWidth: 150,
                    backgroundColor: isActive
                        ? lighten(theme.palette.primary.main, 0.5)
                        : 'transparent',
                    color: isActive
                        ? theme.palette.getContrastText(
                              tag.color
                                  ? lighten(tag.color, 0.5)
                                  : lighten(theme.palette.primary.main, 0.5)
                          )
                        : 'inherit',
                }}
                onClick={() => onSelect && onSelect(tag)}
            />
        );
    };

    return (
        <Box
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                gap: 4,
            }}
        >
            {tags.map((tag) => renderTagChip(tag))}
        </Box>
    );
};
